import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { titleCase } from '../util/commonUtils';
import { HOME_PAGE } from '../constants/routesConstant';

function useBreadcrumbs() {
  const router = useLocation();
  const location = router?.pathname ?? '';
  const [home, ...sublinks] = location?.split('/');
  if (!isEmpty(sublinks)) {
    const links = [];
    sublinks?.forEach(link => {
      const obj = {
        title: titleCase(link),
        url: `/${link}`,
      };
      links.push(obj);
    });
    const breadcrumbs = [{ title: 'Home', url: HOME_PAGE }, ...links];
    return breadcrumbs;
  }
  return [{ title: 'Home', url: HOME_PAGE }];
}

export default useBreadcrumbs;
